module.exports = __webpack_public_path__ + "static/img/call-pass.09a9d588.png";